import React from 'react';

interface OAuthLoginButtonProps {
  provider: string;
  ssoConfigId?: number;
  className?: string;
  disabled?: boolean;
  children: React.ReactNode;
}

export const OAuthLoginButton: React.FC<OAuthLoginButtonProps> = ({
  provider,
  ssoConfigId,
  className = '',
  disabled = false,
  children,
}) => {
  const handleClick = () => {
    if (disabled) return;

    const redirectUrl = window.location.origin + '/dashboard';

    let authUrl = `/_api/auth/oauth_authorize?provider=${provider}&redirect_url=${encodeURIComponent(redirectUrl)}`;
    // Pass SSO config ID for per-tenant/partner OAuth connectors
    if (ssoConfigId) authUrl += `&sso_config_id=${ssoConfigId}`;

    window.location.href = authUrl;
  };

  return (
    <button onClick={handleClick} disabled={disabled} className={className}>
      {children}
    </button>
  );
};
